module.exports = __webpack_public_path__ + "img/[发抖].c05dded6.svg";